import React, {useEffect, useRef, useState} from "react";
import styles from './LeftMenuPromotionItem.module.scss'
import {
    FlyerPageSpotDto,
    ItemsListMenuDto,
    PromoDto,
    PromoItemsDto,
    SelectPageForTabsDto, UserDto
} from "../../../../../../../dtos";
import {useTypedSelector} from "../../../../../../../hooks/useTypeSelector";
import {ReactComponent as ItemIcon} from "../../../../../../../assets/promos&items/item_icon.svg";
import {hideMenu} from "react-contextmenu/modules/actions";
import {
    attachItemsToFlyer, changeQualificationStatusForItems,
} from "../../../../../../../store/actionCreators/promotionsItemsCreators";
import {useDispatch} from "react-redux";
import {ReactComponent as MenuOnHover} from "../../../../../../../assets/promos&items/menu_on_hover.svg";
// import Button from '@material-ui/core/Button';
import {MenuForItems} from "./MenuForItems/menuForItem";
import {CreateEditItemModal} from "./CreateEditItemModal/CreateEditItemModal";
import {
    QualificationForItemComponent
} from "../../../../../../com/QualificationForItemComponent/QualificationForItemComponent";
import {Button} from "@mui/material";


interface PromotionItemInt {
    item: PromoItemsDto;
    isQualification: boolean;
    isUnlinkPromo: boolean;
    frames?: FlyerPageSpotDto[];
    frame?: FlyerPageSpotDto;
    setFrames?: (e: FlyerPageSpotDto[]) => void;
    userName?: string;
    promo?: PromoDto;
    unlinkAllItemFromPromoSelectedPromo?: () => void;
    onEditItem?: (item: PromoItemsDto) => void;
    // statusForApproveAll?: string;
}


export const PromotionItem: React.FC<PromotionItemInt> = (props) => {
    const dispatch = useDispatch();
    let flyerDetailsState = useTypedSelector((state) => state.flyerDetails);
    const promotionsItemsState = useTypedSelector((state) => state.promotionsAndItems);
    let selectedPageState = useTypedSelector<SelectPageForTabsDto>((state) => state.selectPageForTabs);
    let [isHebrew, setHebrewLang] = useState<boolean>(false);
    let [isOpenItemModal, setOpenItemModal] = useState<boolean>(false);


    let [isNewItem, setStatusForNewOrNotForItem] = useState<boolean>(false);

    const [itemQualification, setItemQualificationStatus] = useState<number | undefined>(props.item?.qualificationLevel);
    const [isHoverOnItem, changeHoverOnItemStatus] = useState<boolean>(false);
    const [openItemMenu, setOpenItemMenu] = useState<boolean>(false);
    const [imageSrc, setImageSrc] = useState<string | null>(props.item.fpiImage!);
    const prevOpenItemMenu = useRef(openItemMenu);
    const anchorRef = useRef(null);
    let userDtoStr = localStorage.getItem('userDto');
    let isUserViewer = true;
    let isUserEditor = false;
    if(userDtoStr){
        let userDto: UserDto = JSON.parse(userDtoStr);
        isUserViewer = userDto.role !== 2 && userDto.role !== 3;
        isUserEditor = userDto.role === 2;
    }

    useEffect(() => {
        const currentItem = promotionsItemsState.pages[selectedPageState.pageNo !== 0 ? selectedPageState.pageNo - 1 : selectedPageState.pageNo].items.filter((promoItem: PromoItemsDto) => {
            return promoItem.fpiRecId === props.item.fpiRecId;
        });
        setItemQualificationStatus(props.item?.qualificationLevel);
        setImageSrc(props.item?.fpiImage ? props.item?.fpiImage : ``)
        // const currentItem = promotionsItemsState.items.filter((promoItem: PromoItemsDto) => {
        //    return promoItem.fpiRecId === props.item.fpiRecId;
        // });
        // setItemQualificationStatus(currentItem[0] ? currentItem[0].qualificationLevel : props.item?.qualificationLevel);
        // setImageSrc(currentItem[0] ? currentItem[0].fpiImage : props.item?.qualificationLevel)
        // }, [promotionsItemsState.items]);
    }, [promotionsItemsState.pages[selectedPageState.pageNo !== 0 ? selectedPageState.pageNo - 1 : selectedPageState.pageNo].items, flyerDetailsState]);

    useEffect(() => {
        setItemQualificationStatus(props.item?.qualificationLevel);
    }, [props.item?.qualificationLevel]);

    // useEffect(() => {
    //     setImageSrc(isNewItem ? '' : props.item.fpiImage!);
    // }, [isNewItem])

    const onClickFrame = (e: React.MouseEvent<HTMLElement>) => {
        e.preventDefault();
        hideMenu();
    }

    const onAddNew = () => {
        setStatusForNewOrNotForItem(true);
        setImageSrc('');
        setOpenItemModal(true);
    }
    const onEdit = (e: React.MouseEvent<HTMLElement>) => {
        e.preventDefault();
        e.stopPropagation();
        if (props.onEditItem) {
            props.onEditItem(props.item);
            // setStatusForNewOrNotForItem(false);
            // setImageSrc(props.item.fpiImage!);
            // setOpenItemModal(true);
        }
    }

    const onUnlink = () => {
        let sourcePromo: PromoDto = props.frame ? {...props.frame?.flyerPromos![0]} : {...props.promo};
        dispatch(attachItemsToFlyer(flyerDetailsState.flyRecId, [props.item.fpiRecId!], false, sourcePromo, props.frame?.fpsRecId!))
    }

    const onMouseEnterItem = () => {
        changeHoverOnItemStatus(true);
    }

    const onMouseLeaveItem = () => {
        changeHoverOnItemStatus(false);
        setOpenItemMenu(false);
    }

    const handleToggle = (e: React.MouseEvent<HTMLElement>) => {
        e.preventDefault();
        setOpenItemMenu((prevOpen) => !prevOpen);
    };


    const changeQualificationStatus = () => {
        if (itemQualification !== 0) {
            dispatch(changeQualificationStatusForItems([props.item.fpiRecId!], flyerDetailsState?.flyLacRec?.lacCode!, itemQualification === 1 ? 2 : 1, flyerDetailsState, false, selectedPageState.pageNo !== 0 ? selectedPageState.pageNo - 1 : selectedPageState.pageNo, props.isUnlinkPromo))
            // setItemQualificationStatus(itemQualification === 1 ? 2 : 1);
        }
    }


    useEffect(() => {
        setHebrewLang(flyerDetailsState?.flyLacRec?.lacCode! === 'he-IL')
    }, [flyerDetailsState])

    const clickMenuData: ItemsListMenuDto = {
        setOpen: setOpenItemMenu,
        prevOpen: prevOpenItemMenu,
        open: openItemMenu,
        anchorRef: anchorRef,
    }

    return (
        <div>
            <li className={`${styles.promo_item_wrapper} ${isHebrew ? styles.is_hebrew : ''} ${isHoverOnItem ? styles.hover_style : ''}`}
                onClick={onClickFrame}
                onMouseLeave={onMouseLeaveItem}
                onMouseEnter={onMouseEnterItem}
            >
                <div className={styles.item_wrapper}>
                    <div
                        className={`${styles.item_info} ${props.isQualification ? styles.is_qualification : ''}`}>
                        <div className={styles.item_icon_and_caption_wrapper}>
                            <div className={styles.icon_wrapper}>
                                <ItemIcon/>
                            </div>
                            <div className={styles.item_caption} title={props.item.fpiCaption}>
                                <span>
                                    {`${props.item.fpiCaption}`}
                                </span>
                            </div>

                        </div>
                        {
                            flyerDetailsState.flyFltRec.fltCode !== 3 &&
                            <div className={styles.item_price}>
                                {`${flyerDetailsState.flyLacRec.lacCurrencySymbol} ${props.item.fpiRegularPrice ? props.item.fpiRegularPrice?.toFixed(2) : '0.00'}`}
                            </div>
                        }
                    </div>
                    {props.isQualification &&
                        <Button
                            className={styles.item_qualification_status}
                            onClick={changeQualificationStatus}
                            disabled={isUserViewer || isUserEditor}
                            sx={{
                                "&:disabled": {
                                    opacity: "0.5"
                                }
                            }}
                        >
                            <QualificationForItemComponent item={props.item} editItem={onEdit}
                                                           itemQualification={itemQualification}/>
                        </Button>
                    }
                    {isHoverOnItem &&
                        <div className={styles.menu_for_item}>
                            <Button
                                disableRipple={true}
                                ref={anchorRef}
                                aria-controls={openItemMenu ? 'menu-list-grow' : undefined}
                                aria-haspopup="true"
                                onClick={handleToggle}
                                disabled={isUserViewer}
                                sx={{
                                    "&:disabled": {
                                        opacity: "0.5"
                                    }
                                }}
                            >
                                <MenuOnHover/>
                            </Button>
                            <MenuForItems list={clickMenuData}
                                          makeUnlinkTargetItem={onUnlink}
                                          onCreateNewItem={onAddNew}
                                          onEditExistItem={onEdit}
                                          isUnlinkPromo={props.isUnlinkPromo}
                                          unlinkAllItemFromPromoSelectedPromo={props.unlinkAllItemFromPromoSelectedPromo}
                            />
                        </div>}
                </div>
            </li>

            {isOpenItemModal &&
                <CreateEditItemModal
                    isShow={isOpenItemModal}
                    defaultContentForModal={isNewItem ? {} : props.item}
                    isNewItem={isNewItem}
                    setOpenItemModal={setOpenItemModal}
                    promo={props.promo ? props.promo : {}}
                    lang={flyerDetailsState?.flyLacRec?.lacCode!}
                    imageSrc={imageSrc ? imageSrc : ''}
                    isUnlinkPromo={props.isUnlinkPromo}
                />}

        </div>
    )
}